import { useMemo, useState } from "react";

import { useMediaQuery } from "@/hooks";
import { SEM_MARCAS } from "@/modules/recursos/simulacao";

import { COMFORTABLE } from "../../gantt-fornecedor.utils";
import { ganttScaleOf, monthMinWidth } from "@/shared/components/gantt-carga/gantt-scale";
import { CARGA_FORNECEDOR_COMPACT_QUERY } from "@/shared/components/gantt-carga/mobile";
import type {
  GanttFornecedorObrasProps,
  GanttFornecedorObrasViewModel,
} from "./types-gantt-fornecedor-obras";

export function useGanttFornecedorObras({
  rows,
  marcas = SEM_MARCAS,
  timeline,
  today,
  onConflictHover,
  onConflictLeave,
  onResolverConflito,
}: GanttFornecedorObrasProps): GanttFornecedorObrasViewModel {
  const isMobile = useMediaQuery(CARGA_FORNECEDOR_COMPACT_QUERY);
  const scale = useMemo(() => ganttScaleOf(timeline), [timeline]);
  const [aberto, setAberto] = useState<Set<string>>(new Set());

  return {
    rows,
    marcas,
    today,
    onConflictHover,
    onConflictLeave,
    onResolverConflito,
    scale,
    isMobile,
    unitMinWidth: monthMinWidth(COMFORTABLE, isMobile),
    expandida: (key) => aberto.has(key),
    alternar: (key) =>
      setAberto((atual) => {
        const proximo = new Set(atual);
        if (proximo.has(key)) proximo.delete(key);
        else proximo.add(key);
        return proximo;
      }),
  };
}
